import React from "react";
import styles from "./PdfList.module.css";

const PdfList = ({ pdfs }) => {
  if (!pdfs || pdfs.length === 0) return <p>📭 등록된 PDF가 없습니다.</p>;

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {pdfs.map((pdf, index) => (
          <li key={index} className={styles.item}>
            <a href={pdf.url} target="_blank" rel="noopener noreferrer">
              {pdf.name}
            </a>
            <a href={pdf.url} download className={styles.downloadBtn}>
              Download
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PdfList;
